import { DOCS, type Doc } from './documents'

/**
 * Which legal document a path names: `/privacy` and `/terms` (a trailing slash is
 * tolerated, case is not significant). Anything else is the app.
 *
 * These two paths are the PUBLIC URLs the App Store requires — App Store Connect's
 * privacy-policy field, and the links the paywall's disclosure carries (guidelines
 * 5.1.1 and 3.1.2). They are served by the App itself rather than by the marketing
 * site so that they render `documents.ts`, the same source the in-app sheet renders:
 * a second, hand-maintained copy of a legal document is the drift this avoids.
 */
export function legalDocForPath(pathname: string): Doc | null {
  const path = pathname.replace(/\/+$/, '').toLowerCase()
  return DOCS.find((d) => `/${d.id}` === path) ?? null
}
